'use client'

const ResultBanner = () => {
	return <div>ResultBanner</div>
}

export default ResultBanner
